import type { ActionType } from "typesafe-actions";
import { createReducer } from "typesafe-actions";

import { EWalkThroughSteps } from "app/pages/sales-intelligence/sub-modules/onboarding/types/enums";
import type { WalkThroughState } from "app/pages/sales-intelligence/sub-modules/onboarding/types/WalkThroughType";
import * as ac from "app/pages/sales-intelligence/sub-modules/onboarding/walk-through/store/actions/actions";

export const INITIAL_WALK_THROUGH: WalkThroughState = {
    isOpen: false,
    step: EWalkThroughSteps.ListInfo,
};

const walkThroughReducer = createReducer<WalkThroughState, ActionType<typeof ac>>(INITIAL_WALK_THROUGH)
    .handleAction(
        ac.setWalkThrough,
        (state, { payload }): WalkThroughState => ({
            ...state,
            ...payload,
        }),
    )
    .handleAction(
        ac.setWalkThroughIsOpen,
        (state, { payload }): WalkThroughState => ({
            ...state,
            isOpen: payload,
        }),
    );

export default walkThroughReducer;
